<template>
  <div class="pg-criteria-menus">
    <span
      class="pg-criteria-menus__front-item"
      v-for="front in frontMenus"
      :key="front.id"
      @click="seach(front.id)"
      >{{ front.name }}</span
    >
    <template v-if="otherMenus?.length > 0">
      <Dropdown class="pg-criteria-menus__dropdown" trigger="click" @command="seach">
        <span class="pg-criteria-menus__dropdown-title"
          >更多<i class="el-icon-arrow-down el-icon--right"></i
        ></span>
        <template v-slot:dropdown>
          <DropdownMenu class="pg-criteria-menus__dropdown-menu">
            <DropdownItem
              class="pg-criteria-menus__dropdown-down-item"
              v-for="other in otherMenus"
              :key="other.id"
              size="small"
              type="primary"
              :plain="false"
              round
              circle="false"
              :command="other.id"
              >{{ other.name }}</DropdownItem
            >
          </DropdownMenu>
        </template>
      </Dropdown>
    </template>
    <template v-if="customMenus?.length > 0">
      <Dropdown class="pg-criteria-menus__dropdown" trigger="click" @command="seach">
        <span class="pg-criteria-menus__dropdown-title"
          >自定义查询组合<i class="el-icon-arrow-down el-icon--right"></i
        ></span>
        <template v-slot:dropdown>
          <DropdownMenu class="pg-criteria-menus__dropdown-menu">
            <DropdownItem
              class="pg-criteria-menus__dropdown-down-item"
              v-for="custom in customMenus"
              :key="custom.id"
              size="small"
              type="primary"
              :plain="false"
              round
              circle="false"
              :command="custom.id"
              >{{ custom.name }}</DropdownItem
            >
          </DropdownMenu>
        </template>
      </Dropdown>
    </template>
  </div>
</template>
<script setup>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'

defineProps({
  frontMenus: Array,
  otherMenus: Array,
  customMenus: Array,
})

const emit = defineEmits(['seach'])
const seach = (id) => {
  emit('seach', id)
}
</script>
<style lang="scss">
@import '../style/criteria-menus.scss';
</style>
